<template>
  <paginate
    :page-count="paginator.last_page"
    :page-range="11"
    :margin-pages="2"
    v-model="paginator.current_page"
    :click-handler="getRecords"
    :prev-text="'&laquo'"
    :next-text="'&raquo'"
    :container-class="'pagination'"
    :prev-class="'page-item'"
    :prev-link-class="'page-link'"
    :page-class="'page-item'"
    :page-link-class="'page-link'"
    :next-class="'page-item'"
    :next-link-class="'page-link'"
    :active-class="'active green_btn'">
  </paginate>
</template>
<script>
import Paginate from 'vuejs-paginate'

export default {
  props: ['paginator', 'getRecords'],
  components: {Paginate}
}
</script>
